/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AttributesIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Attributes',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M6.25 5.634V3a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1v1H24v2H9.756a11.028 11.028 0 0 0 .869 4H22a2 2 0 0 1-2 2h-8.214a7.636 7.636 0 0 0 2.628 2.219l1.358.682-3.827 1.921-.011.006A13.187 13.187 0 0 1 6.25 5.634Zm17.817 13.5-.012.006-3.826 1.92 1.357.681A7.675 7.675 0 0 1 24.247 24H16a2 2 0 0 0-2 2h11.394a11.048 11.048 0 0 1 .851 4H12v2h14.25v1a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-2.678a13.189 13.189 0 0 0-5.683-11.193ZM28.75 2h-1.5a1 1 0 0 0-1 1v2.634c0 3.793-1.83 7.163-4.664 8.586l-8.742 4.389c-4.006 2.012-6.594 6.61-6.594 11.713V33a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-2.678c0-3.792 1.83-7.162 4.664-8.586l8.742-4.388c4.006-2.012 6.594-6.61 6.594-11.714V3a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
